import type { crm as crmEn } from "../en/crm";

export const crm: typeof crmEn = {
  fields: {
    name: "Jméno",
    firstName: "Jméno",
    lastName: "Příjmení",
    street: "Ulice",
    city: "Město",
    postalCode: "PSČ",
    country: "Země",
    birthDate: "Datum narození",
    nationality: "Národnost",
    passportNumber: "Číslo pasu",
    passportExpiry: "Platnost pasu",
  },
  leads: {
    title: "Poptávky",
    subtitle: "Prodejní trychtýř — poptávky předtím, než se stanou objednávkami",
    newLead: "Nová poptávka",
    kanban: "Kanban",
    searchPlaceholder: "Hledat podle jména, e-mailu, telefonu nebo čísla…",
    agent: "Agent",
    unassigned: "Nepřiřazeno",
    kindFacet: "Typ",
    kinds: {
      inquiry: "Poptávka",
      callback: "Žádost o zavolání",
    },
    noLeads: "Nenalezeny žádné poptávky",
    table: {
      lead: "Poptávka",
      contact: "Kontakt",
      interest: "Zájem",
      pax: "Osoby",
      value: "Hodnota",
      agent: "Agent",
    },
  },
  leadKanban: {
    title: "Kanban poptávek",
    subtitle: "Přetažením karet posouvejte poptávky trychtýřem",
    tableView: "Tabulka",
    loadError: "Chyba při načítání poptávek.",
    lostCount_one: "{{count}} ztracená poptávka (v kanbanu se nezobrazuje)",
    lostCount_few: "{{count}} ztracené poptávky (v kanbanu se nezobrazují)",
    lostCount_other: "{{count}} ztracených poptávek (v kanbanu se nezobrazují)",
    generalInquiry: "Obecná poptávka",
    noLeads: "Žádné poptávky",
  },
  leadDetail: {
    createdAt: "Vytvořeno {{date}}",
    deleteConfirm:
      "Smazat poptávku {{number}}? Propojené zprávy a objednávky si historii zachovají — odstraní se pouze záznam poptávky.",
    deleteFailed: "Poptávku se nepodařilo smazat",
    buildOffer: "Sestavit nabídku",
    contactSection: "Kontakt",
    assignedAgent: "Přiřazený agent",
    unassignedOption: "— Nepřiřazeno —",
    interestSection: "Zájem",
    noneCustomOption: "— Žádný / vlastní —",
    noneOption: "— Žádná —",
    requestedDate: "Požadovaný termín",
    estimatedValue: "Odhadovaná hodnota ({{currency}})",
    adults: "Dospělí",
    children: "Děti",
    pipelineSection: "Pipeline",
    nextAction: "Další akce (zavolat zpět)",
    lostReason: "Důvod ztráty",
    customerNotes: "Poznámky zákazníka",
    internalNotes: "Interní poznámky",
    conversionSection: "Konverze",
    viewOrder: "Zobrazit objednávku",
    createOrder: "Vytvořit objednávku",
    leadScore: "Skóre poptávky",
    tripProfile: "Profil zájezdu",
    hotel: {
      title: "Hotelový pobyt (z poptávky)",
      stay: "Termín pobytu",
      nights_one: "{{count}} noc",
      nights_few: "{{count}} noci",
      nights_other: "{{count}} nocí",
      room: "Pokoj",
      meal: "Strava",
      departure: "Odlet z",
      included: "v ceně",
    },
    custom: {
      title: "Poptávka na míru",
      where: "Kam",
      whereUnknown: "Neurčeno (zákazník zatím neví)",
      window: "Termínové okno",
      windowFrom: "od {{date}}",
      windowTo: "do {{date}}",
      duration_one: "{{count}} den",
      duration_few: "{{count}} dny",
      duration_other: "{{count}} dní",
      durationLabel: "Délka",
      tripType: "Typ cesty",
      originPath: "Stránka původu",
    },
    sources: {
      web_form: "Web — poptávka zájezdu",
      web_custom: "Web — zájezd na míru",
      contact_form: "Web — kontaktní formulář",
      email: "E-mail",
      phone: "Telefon",
      manual: "Zadáno ručně",
      web_callback: "Web — žádost o zavolání",
    },
    departure: {
      title: "Termín z poptávky",
      departure: "Odjezd",
      lifecycle: "Stav odjezdu",
      notListed: "Nejde o vypsaný odjezd",
      period: "Požadované období",
      flexibility: "Flexibilita",
    },
    childrenAges: "Děti: {{ages}}",
    autoRoutedGarant: "Automaticky přiřazeno přes garanta destinace",
    autoRoutedRoundRobin: "Automaticky přiřazeno rotací (round-robin)",
    attributionSection: "Atribuce",
    source: "Zdroj",
    campaign: "Kampaň",
    medium: "Médium",
    clickId: "Click ID",
    aiSuggestedReply: "První odpověď navržená AI",
    useAsReply: "Použít jako odpověď",
    noContactEmail: "Poptávka nemá kontaktní e-mail",
    profile: {
      fit: "Privátní na míru",
      guided: "Poznávací s průvodcem",
      stay: "Pobytové u moře",
      service: "Služba",
      economy: "Economy",
      premium: "Premium economy",
      business: "Business",
      fixedDates: "Pevné termíny",
      plusMinusWeek: "± týden",
      flexible: "Flexibilní",
      firstAsia: "Poprvé v dálce",
      experienced: "Dálkové cesty už zná",
      expert: "Ostřílený cestovatel",
    },
  },
  customers: {
    title: "Zákazníci",
    subtitle: "Přehled všech zákazníků",
    newCustomer: "Nový zákazník",
    totalCustomers: "Zákazníků celkem",
    newsletterSubscribers: "Odběratelé newsletteru",
    newThisMonth: "Noví tento měsíc",
    searchPlaceholder: "Hledat podle jména, e-mailu nebo telefonu…",
    source: "Zdroj",
    noCustomers: "Nenalezeni žádní zákazníci",
    newsletterBadge: "Newsletter",
    table: {
      customer: "Zákazník",
      contact: "Kontakt",
      address: "Adresa",
      registered: "Registrace",
      trips: "Zájezdy",
      spent: "Utraceno",
    },
  },
  newCustomer: {
    subtitle: "Ručně přidat zákazníka do databáze",
    basicInfo: "Základní údaje",
    address: "Adresa",
    personalDetails: "Osobní údaje",
    notesPreferences: "Poznámky a preference",
    notesPlaceholder: "Interní poznámky o zákazníkovi…",
    subscribeNewsletter: "Přihlásit k odběru newsletteru",
    createCustomer: "Vytvořit zákazníka",
    createFailed: "Zákazníka se nepodařilo vytvořit",
    fillRequired: "Vyplňte prosím jméno, příjmení a e-mail",
    phonePlaceholder: "+420 123 456 789",
    nationalityPlaceholder: "česká",
    countries: {
      us: "Spojené státy",
      gb: "Spojené království",
      au: "Austrálie",
      ca: "Kanada",
      vn: "Vietnam",
      other: "Jiná",
    },
  },
  customerDetail: {
    notFound: "Zákazník nenalezen nebo došlo k chybě.",
    deleteConfirm: "Opravdu chcete tohoto zákazníka smazat? Tuto akci nelze vrátit zpět.",
    deleteFailed: "Zákazníka se nepodařilo smazat",
    messageSent: "Zpráva odeslána",
    sendFailed: "Odeslání se nezdařilo",
    generatingContract: "Generuji smlouvu…",
    generatingInvoice: "Generuji fakturu…",
    contractDownloaded: "Smlouva stažena",
    invoiceDownloaded: "Faktura stažena",
    downloadError: "Chyba při stahování",
    emailsSection: "E-maily",
    documentsSection: "Dokumenty",
    sendEmail: "Odeslat e-mail",
    sendConfirmation: "Odeslat potvrzení",
    sendContract: "Odeslat smlouvu",
    sendInvoice: "Odeslat fakturu",
  },
  customerInfo: {
    title: "Informace o zákazníkovi",
    newsletterSubscription: "Odběr newsletteru",
    registered: "Registrace: {{date}}",
    validUntil: "(platný do {{date}})",
    newsletterActive: "Newsletter aktivní",
    newsletterInactive: "Newsletter neaktivní",
    source: "Zdroj: {{source}}",
  },
  customerStats: {
    totalSpent: "Celkem utraceno",
    tripsCount: "Počet zájezdů",
    orders: "Objednávky",
    score: "Skóre",
  },
  customerOrders: {
    title: "Historie objednávek",
    newOrder: "Nová objednávka",
    unknownTrip: "Neznámý zájezd",
    createdAt: "Vytvořeno: {{date}}",
    contract: "Smlouva",
    invoice: "Faktura",
    downloadContract: "Stáhnout smlouvu",
    downloadInvoice: "Stáhnout fakturu",
    email: "E-mail",
    empty: "Žádné objednávky",
    timeline: "Časová osa",
    firstTrip: "První zájezd: {{date}}",
    lastTrip: "Poslední zájezd: {{date}}",
  },
  communications: {
    title: "Komunikace",
    newMessage: "Nová zpráva",
    sent: "Odesláno",
    received: "Přijato",
    delivered: "Doručeno",
    opened: "Otevřeno",
    from: "Od: {{name}}",
    empty: "Žádná komunikace",
    types: {
      email: "E-mail",
      phone: "Telefon",
      sms: "SMS",
      note: "Poznámka",
    },
  },
  gdpr: {
    title: "GDPR",
    anonymized: "Anonymizováno",
    description:
      "Exportujte všechny osobní údaje, které o zákazníkovi evidujeme (přenositelnost), nebo jeho osobní údaje vymažte se zachováním finančních záznamů (právo být zapomenut).",
    exportJson: "Export JSON",
    exportCsv: "Export CSV",
    exportFailed: "Export se nezdařil",
    anonymize: "Anonymizovat (vymazat)",
    anonymizing: "Anonymizuji…",
    anonymizeConfirm:
      "Trvale anonymizovat osobní údaje tohoto zákazníka? Objednávky a faktury zůstanou zachovány (anonymizované). Tuto akci nelze vrátit zpět.",
    anonymizeFailed: "Anonymizace se nezdařila",
    adminOnly: "Zákazníka může vymazat pouze administrátor.",
  },
  interestProfile: {
    title: "Profil zájmů",
    updated: "aktualizováno {{date}}",
    stats: {
      tripViews: "Zobrazení zájezdů",
      readingMin: "Minuty čtení",
      inquiries: "Poptávky",
      orders: "Objednávky",
      nlOpens: "Otevření NL",
      nlClicks: "Kliknutí NL",
    },
    destinationsDerived: "Destinace (odvozeno z chování)",
    tripStyleDerived: "Styl zájezdu (odvozeno)",
    weight: "váha {{value}}",
    chosenByContact: "Zvoleno kontaktem (centrum preferencí)",
    typeChip: "typ: {{type}}",
    monthlyDigest: "pouze měsíční souhrn",
    everyEdition: "každé vydání",
    pausedUntil: "pozastaveno do {{date}}",
    lastEngaged: "Naposledy aktivní {{date}}",
    bounces_one: "{{count}} vrácený e-mail",
    bounces_few: "{{count}} vrácené e-maily",
    bounces_other: "{{count}} vrácených e-mailů",
  },
  newsletters: {
    title: "Newslettery",
    wave: "vlna {{wave}}",
    variant: "varianta {{variant}}",
    clicked: "kliknuto",
    opened: "otevřeno",
    viewEmail: "Zobrazit e-mail",
    badRecTitle: "Špatné doporučení — řekněte enginu proč",
    badRec: "Špatné doporučení",
    recommended: "Doporučeno: {{titles}}",
    flagPlaceholder: "Proč to pro ně bylo špatně? (např. „severní Vietnam už projeli dvakrát“)",
    flagIt: "Nahlásit",
    flagged: "Nahlášeno — analytik se z toho poučí",
    reconstructionTitle: "Rekonstrukce odeslaného e-mailu",
    sentEmail: "Odeslaný e-mail",
    reconstructionFailed: "Rekonstrukce se nezdařila",
    loadFailed: "E-mail se nepodařilo načíst",
  },
  sendModal: {
    titleEmail: "Odeslat e-mail",
    titleDocument: "Odeslat dokument",
    recipient: "Příjemce:",
    orderOptional: "Objednávka (volitelné)",
    withoutOrder: "Bez objednávky",
    template: "Šablona",
    selectTemplate: "Vyberte šablonu",
    variablesHint:
      "Proměnné jako jméno zákazníka, číslo objednávky apod. budou automaticky nahrazeny.",
    generateAndSend: "Vygenerovat a odeslat",
  },
  inbox: {
    title: "Inbox",
    subtitle: "Sjednocené zprávy — Gmail, sociální sítě, telefon",
    syncNow: "Synchronizovat",
    synced_one: "Synchronizováno — {{count}} nová zpráva",
    synced_few: "Synchronizováno — {{count}} nové zprávy",
    synced_other: "Synchronizováno — {{count}} nových zpráv",
    syncFailed: "Synchronizace se nezdařila",
    mailboxConnected: "Schránka připojena",
    oauthMisconfigured:
      "OAuth je špatně nakonfigurovaný: redirect URI tohoto API originu není registrována v konzoli Google Cloud.",
    mailboxConnectFailed: "Schránku se nepodařilo připojit",
    searchPlaceholder: "Hledat ve zprávách…",
    channel: "Kanál",
    noMessages: "Žádné zprávy",
    unknownSender: "Neznámý",
    toAddress: "Komu: {{address}}",
    noSubject: "(bez předmětu)",
    aiTriage: "AI třídění: {{intent}}",
    createLead: "Vytvořit poptávku",
    channels: {
      email: "E-mail",
      instagram: "Instagram",
      facebook: "Facebook",
      webchat: "Webový chat",
      phone: "Telefon",
      webInquiry: "Poptávka zájezdu",
      contactForm: "Kontaktní formulář",
    },
    intents: {
      sales: "prodej",
      question: "dotaz",
      supplier: "dodavatel",
      noise: "šum",
    },
    settingsTitle: "Nastavení inboxu",
    oauthNotConfigured:
      "Google OAuth klient není nakonfigurován — nastavte GDRIVE_CLIENT_ID / GDRIVE_CLIENT_SECRET.",
    connectedMailboxes: "Připojené schránky",
    test: "Test",
    testFailed: "Selhalo",
    disconnect: "Odpojit",
    noMailboxes: "Zatím nejsou připojeny žádné schránky.",
    connectMailbox: "Připojit schránku",
    callSummary: "Shrnutí hovoru",
    proposedFollowUp: "Navržený follow-up {{date}}",
    scheduled: "Naplánováno",
    followUpScheduled: "Follow-up naplánován",
    followUpFailed: "Follow-up se nepodařilo naplánovat",
    attachment: "příloha",
    attachmentN: "Příloha {{n}}",
    parseDocument: "Vytěžit dokument",
    noParsedFields: "Nenalezena žádná pole dodavatelského dokumentu.",
    replyTo: "Odpověď pro",
    draftReply: "Navrhnout odpověď",
    draftFailed: "Odpověď se nepodařilo navrhnout.",
    replyPlaceholder: "Napište odpověď…",
  },
};
